import { ProjectActions } from '@store/reducers/project'
import { all, takeEvery } from 'redux-saga/effects'

import { moveTo } from './moveTo'

export function* projectSaga() {
  yield all([takeEvery(ProjectActions.moveToWorkspace, moveTo)])
}
